import { render, staticRenderFns } from "./sub.vue?vue&type=template&id=5abceef6&scoped=true&"
import script from "./sub.vue?vue&type=script&lang=ts&"
export * from "./sub.vue?vue&type=script&lang=ts&"
import style0 from "./sub.vue?vue&type=style&index=0&id=5abceef6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abceef6",
  null
  
)

export default component.exports